import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BadgeModule } from 'primeng/badge';

@Component({
  selector: 'app-list-item',
  standalone: true,
  imports: [BadgeModule,CommonModule],
  templateUrl: './list-item.component.html',
  styleUrl: './list-item.component.scss'
})
export class ListItemComponent {

  @Input() item:any
  constructor(private router: Router){
  
  }
  goToRichieste() {
    console.log(this.item)
    let url
    if(this.item.sequenza=='sequenziamento'){
      url='sequenziamento'
    }else if(this.item.sequenza=='cariotipo'){
      url='cariotipo'
    }
    if(url){
      this.router.navigate(['/'+url],{
        queryParams:{
          compositionId:this.item.composition_uid_value,
          ehrId:this.item.ehrid
        }
      })
    }
    }
}
